module.exports = __webpack_public_path__ + "img/Cupet.6c0a7970.webp";